import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 3),
    width: "500px",
  },
  buttonsWrapper: {
    margin: theme.spacing(2, 0, 0, 0),
  },
  button: {
    width: "120px",
  },
  paper: {
    display: "flex",
    margin: theme.spacing(2, 0),
    alignItems: "center",
  },
  divider: {
    height: 28,
    margin: 4,
  },
  input: {
    padding: theme.spacing(0, 1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));
